import type { TripListPrice } from './tripListTypes'

export function getValidTripListMemberPrice(price: TripListPrice): number | undefined {
  if (price.price === undefined) return undefined
  if (price.memberPrice === undefined) return undefined
  if (price.memberPrice <= 0) return undefined
  if (price.memberPrice >= price.price) return undefined
  return price.memberPrice
}

export function getTripListDisplayPrice(price: TripListPrice, luxPlusEnabled: boolean): number | undefined {
  if (luxPlusEnabled) {
    const memberPrice = getValidTripListMemberPrice(price)
    if (memberPrice !== undefined) return memberPrice
  }

  return price.price
}
